import { DEFAULT_ROLLBACK } from '../constants';

const defaultRollback = {
  type: DEFAULT_ROLLBACK
};

export default defaultRollback;
